export default "__VITE_ASSET__BEkjdJ_l__"